import { useEffect } from 'react';

export const useHeaderHeight = () => {
  useEffect(() => {
    // Функция для обновления высоты хедера
    const updateHeaderHeight = () => {
      const headerElement = document.querySelector('[name="header-frontend"]');
      if (headerElement) {
        const height = headerElement.getBoundingClientRect().height;
        // Устанавливаем CSS-переменную --header-height
        document.documentElement.style.setProperty('--header-height', `${height}px`);
      }
    };

    // Инициализация высоты при монтировании компонента
    updateHeaderHeight();

    // Используем ResizeObserver для отслеживания изменений размеров хедера
    const headerElement = document.querySelector('[name="header-frontend"]');
    let resizeObserver: ResizeObserver | null = null;
    if (headerElement) {
      resizeObserver = new ResizeObserver(() => {
        updateHeaderHeight();
      });
      resizeObserver.observe(headerElement);
    }

    // Также добавляем прослушивание изменения размера окна
    window.addEventListener('resize', updateHeaderHeight);

    // Очистка при размонтировании компонента
    return () => {
      if (resizeObserver && headerElement) {
        resizeObserver.unobserve(headerElement);
        resizeObserver.disconnect();
      }
      window.removeEventListener('resize', updateHeaderHeight);
    };
  }, []);
};
